import React from 'react';
import { CardFooter } from 'reactstrap';
import { PayerPagination } from './PayerPagination';

type PayerPaginationFooterProps = {
  numberOfPages: number | null;
  page: number;
  setPage: (newPage: number) => void;
};

const PayerPaginationFooter = ({ numberOfPages, page, setPage }: PayerPaginationFooterProps) => {
  return (
    <CardFooter className="text-center">
      {numberOfPages && <PayerPagination numberOfPages={numberOfPages} page={page} setPage={setPage} />}
    </CardFooter>
  );
};

export { PayerPaginationFooter };
